import React, { useState } from 'react';
import Icons from './Icons';
import { Card } from './ui';

const FantasyPlayerCard = ({
    player,
    isBest,
    isWorst,
    correctFantasyPoints,
    FANTASY_SCORING
}) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <Card
            className={`mb-4 border-l-4 ${correctFantasyPoints >= 10 ? 'border-green-400' :
                    correctFantasyPoints < 0 ? 'border-red-400' :
                        isBest ? 'border-yellow-400' :
                            isWorst ? 'border-gray-400' :
                                'border-transparent'
                }`}
        >
            <div className="flex items-center justify-between" onClick={() => setExpanded(!expanded)}>
                <div className="flex items-center space-x-3 flex-1">
                    <div className={`
            px-2 py-1 rounded text-xs font-bold
            ${player.tier === 1 ? 'bg-yellow-100 text-yellow-800' :
                            player.tier === 2 ? 'bg-gray-100 text-gray-800' :
                                'bg-orange-100 text-orange-800'}
          `}>
                        T{player.tier}
                    </div>
                    <div className="min-w-0">
                        <div className="flex items-center">
                            <h3 className="font-bold text-forest-900 dark:text-gray-100 truncate mr-2">{player.player_name}</h3>
                            {isBest && <Icons.Trophy className="w-4 h-4 text-yellow-500" />}
                            {isWorst && <Icons.Frown className="w-4 h-4 text-gray-500" />}
                        </div>
                        <div className="text-xs text-gray-500 dark:text-gray-400">
                            {player.score || 'N/A'} / {player.quota || 'N/A'} (Quota)
                        </div>
                    </div>
                </div>
                <div className="text-right flex-shrink-0">
                    <div className={`text-xl font-bold ${correctFantasyPoints >= 10 ? 'text-green-600 dark:text-green-400' :
                            correctFantasyPoints < 0 ? 'text-red-600 dark:text-red-400' :
                                'text-blue-600 dark:text-blue-400'
                        }`}>
                        {correctFantasyPoints}
                    </div>
                    <div className="text-xs text-gray-400 uppercase">Points</div>
                </div>
            </div>

            {expanded && (
                <div className="mt-4 pt-4 border-t border-gray-100 dark:border-gray-700">
                    <div className="grid grid-cols-2 gap-4 mb-3">
                        <div className="bg-gray-50 dark:bg-navy-700 p-2 rounded text-center">
                            <div className="text-xs text-gray-500 dark:text-gray-400 uppercase">Skins</div>
                            <div className="font-bold text-blue-600 dark:text-blue-400 flex items-center justify-center gap-1">
                                <Icons.Target className="w-3 h-3" />
                                {player.skins}
                            </div>
                        </div>
                        <div className="bg-gray-50 dark:bg-navy-700 p-2 rounded text-center">
                            <div className="text-xs text-gray-500 dark:text-gray-400 uppercase">CTPs</div>
                            <div className="font-bold text-purple-600 dark:text-purple-400 flex items-center justify-center gap-1">
                                <Icons.Location className="w-3 h-3" />
                                {player.ctps}
                            </div>
                        </div>
                    </div>

                    <div className="text-sm">
                        <span className="text-gray-500 dark:text-gray-400">Picked By: </span>
                        <span className="font-medium text-gray-800 dark:text-gray-200">{player.picked_by || 'None'}</span>
                    </div>
                </div>
            )}
        </Card>
    );
};

export default FantasyPlayerCard;
